import React from 'react';

const FoodDeliveryLoader = () => {
  return (
    <>
      <style>
        {`
          @keyframes bounce {
            0%, 100% {
              transform: translateY(0);
            }
            50% {
              transform: translateY(-12px);
            }
          }

          @keyframes steam {
            0% {
              opacity: 0;
              transform: translateY(0) scaleX(1);
            }
            50% {
              opacity: 1;
              transform: translateY(-8px) scaleX(1.1);
            }
            100% {
              opacity: 0;
              transform: translateY(-16px) scaleX(0.8);
            }
          }

          @keyframes pulse {
            0%, 100% {
              opacity: 1;
            }
            50% {
              opacity: 0.6;
            }
          }

          @keyframes spin {
            from {
              transform: rotate(0deg);
            }
            to {
              transform: rotate(360deg);
            }
          }

          @keyframes wave {
            0%, 100% {
              transform: rotate(-3deg);
            }
            50% {
              transform: rotate(3deg);
            }
          }

          .food-loader-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 40px;
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;
          }

          .food-loader-plate {
            position: relative;
            width: 120px;
            height: 120px;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .food-loader-bowl {
            position: relative;
            width: 80px;
            height: 50px;
            background: linear-gradient(135deg, #FF6B35 0%, #F7931E 100%);
            border-radius: 0 0 40px 40px;
            box-shadow: 0 8px 24px rgba(255, 107, 53, 0.3);
            animation: wave 1s ease-in-out infinite;
          }

          .food-loader-bowl::before {
            content: '';
            position: absolute;
            top: -8px;
            left: -5px;
            right: -5px;
            height: 16px;
            background: linear-gradient(135deg, #FF8C5A 0%, #FFB347 100%);
            border-radius: 8px;
          }

          .food-loader-steam-container {
            position: absolute;
            top: -30px;
            left: 50%;
            transform: translateX(-50%);
            display: flex;
            gap: 8px;
          }

          .food-loader-steam {
            width: 8px;
            height: 20px;
            background: linear-gradient(to top, rgba(200, 200, 200, 0.6), transparent);
            border-radius: 4px;
            animation: steam 1.5s ease-in-out infinite;
          }

          .food-loader-steam:nth-child(1) {
            animation-delay: 0s;
          }

          .food-loader-steam:nth-child(2) {
            animation-delay: 0.3s;
            height: 24px;
          }

          .food-loader-steam:nth-child(3) {
            animation-delay: 0.6s;
          }

          .food-loader-utensils {
            position: absolute;
            bottom: 10px;
            display: flex;
            gap: 40px;
          }

          .food-loader-fork,
          .food-loader-spoon {
            width: 6px;
            height: 35px;
            background: linear-gradient(135deg, #C0C0C0 0%, #E8E8E8 50%, #A0A0A0 100%);
            border-radius: 3px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
          }

          .food-loader-fork {
            animation: bounce 0.8s ease-in-out infinite;
            animation-delay: 0s;
          }

          .food-loader-fork::before {
            content: '';
            position: absolute;
            top: -12px;
            left: 50%;
            transform: translateX(-50%);
            width: 14px;
            height: 16px;
            background: linear-gradient(135deg, #C0C0C0 0%, #E8E8E8 50%, #A0A0A0 100%);
            border-radius: 2px 2px 0 0;
            clip-path: polygon(0 100%, 15% 0, 25% 0, 25% 70%, 40% 70%, 40% 0, 50% 0, 50% 70%, 60% 70%, 60% 0, 75% 0, 75% 70%, 85% 0, 100% 100%);
          }

          .food-loader-spoon {
            animation: bounce 0.8s ease-in-out infinite;
            animation-delay: 0.2s;
          }

          .food-loader-spoon::before {
            content: '';
            position: absolute;
            top: -16px;
            left: 50%;
            transform: translateX(-50%);
            width: 16px;
            height: 20px;
            background: linear-gradient(135deg, #C0C0C0 0%, #E8E8E8 50%, #A0A0A0 100%);
            border-radius: 50% 50% 40% 40%;
          }

          .food-loader-dots {
            display: flex;
            gap: 8px;
            margin-top: 24px;
          }

          .food-loader-dot {
            width: 10px;
            height: 10px;
            background: #FF6B35;
            border-radius: 50%;
            animation: bounce 0.6s ease-in-out infinite;
          }

          .food-loader-dot:nth-child(1) {
            animation-delay: 0s;
            background: #FF6B35;
          }

          .food-loader-dot:nth-child(2) {
            animation-delay: 0.15s;
            background: #F7931E;
          }

          .food-loader-dot:nth-child(3) {
            animation-delay: 0.3s;
            background: #FFB347;
          }

          .food-loader-text {
            margin-top: 16px;
            font-size: 14px;
            font-weight: 600;
            color: #4A4A4A;
            letter-spacing: 1px;
            animation: pulse 1.5s ease-in-out infinite;
          }

          .food-loader-subtext {
            margin-top: 4px;
            font-size: 12px;
            color: #888888;
          }
        `}
      </style>
      <div className="food-loader-container">
        <div className="food-loader-plate">
          <div className="food-loader-bowl">
            <div className="food-loader-steam-container">
              <div className="food-loader-steam"></div>
              <div className="food-loader-steam"></div>
              <div className="food-loader-steam"></div>
            </div>
          </div>
          <div className="food-loader-utensils">
            <div className="food-loader-fork"></div>
            <div className="food-loader-spoon"></div>
          </div>
        </div>
        <div className="food-loader-dots">
          <div className="food-loader-dot"></div>
          <div className="food-loader-dot"></div>
          <div className="food-loader-dot"></div>
        </div>
        <div className="food-loader-text">Preparing your Menu</div>
        <div className="food-loader-subtext">This won't take long...</div>
      </div>
    </>
  );
};

export default FoodDeliveryLoader;
